import {Box} from '@mui/material';
import {AppTable} from 'components/table';
import {useBoardRedux, useDebounceEffect, useTableBoardData, useTableBoardHelper, useWorkSpaceRedux} from 'hooks';
import {useTenantSettingHelper} from 'hooks/settings';
import {ItemDataResponse} from 'models/board';
import {TenantSettingsKeysEnum} from 'models/settings';
import React, {useCallback, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {appRoutes} from 'routes';
import {boardSelector} from 'store/boards/boardSlice';
import {sprintSelector} from 'store/sprints';
import {RenderBoardItemCommonTypes} from '../RenderBoardViews';
import {TableViewMultiRowSelectedActions} from './BarodTableViewActions';
import TableBoardViewAddNewItem from './components/TableBoardViewAddNewItem';
interface TableBoardViewProps extends RenderBoardItemCommonTypes {}

export const TableBoardView: React.FC<TableBoardViewProps> = ({itemStatuses}) => {
    const {items, getAllitemData, getAllitemDataLoading, totalCount, setPage, rowsPerPage, setRowsPerPage, page} =
        useTableBoardData();
    const {isSettingEnabled} = useTenantSettingHelper();
    const {selectedDefaultForm} = useBoardRedux();
    // const {selectedWorkSpace} = useWorkSpaceRedux();
    const {selectedSprint} = useSelector(sprintSelector);
    const navigate = useNavigate();
    const {tenantId, workspaceId, boardId} = useParams();
    // const {allUsersByBoardIdLoading, allUsersByBoardIdResponse, getAllUsers} = useGetAllUsersByBoardId();

    const [selectedRow, setRowSelection] = useState<ItemDataResponse[]>([]);
    const handleRowClick = useCallback(
        (row: ItemDataResponse) => {
            navigate(
                appRoutes.workspace.boadListingWithTicket(tenantId, workspaceId, boardId, row.ticketNo.toString()),
            );
        },
        [navigate, tenantId, workspaceId, boardId],
    );
    const {tableBoardColumns} = useTableBoardHelper();
    const {search} = useSelector(boardSelector);

    // const usersSelectList = useMemo<SelectOptionsType[]>(() => {
    //     if (!allUsersByBoardIdResponse) return [];
    //     return allUsersByBoardIdResponse.map(u => ({
    //         label: `${u.firstName} ${u.lastName}`,
    //         value: u.id,
    //     }));
    // }, [allUsersByBoardIdResponse]);

    // useEffect(() => {
    //     if (selectedBoard?.id && selectedWorkSpace?.id) {
    //         getAllUsers({
    //             variables: {
    //                 filter: {
    //                     boardId: selectedBoard.id,
    //                     workspaceId: selectedWorkSpace.id,
    //                 },
    //             },
    //         });
    //     }
    // }, [selectedBoard, selectedWorkSpace]);

    const refreshTableData = () => {};

    useDebounceEffect(
        () => {
            const refreshData = () => {
                if (boardId)
                    getAllitemData({
                        variables: {
                            take: rowsPerPage,
                            skip: page * rowsPerPage,
                            filters: {
                                boardSlugs: [boardId],
                                filters: {
                                    search: search,
                                },
                                sprintIds: [selectedSprint?.id ?? ''],
                            },
                        },
                    });
            };
            const isSprintEnabled = isSettingEnabled([TenantSettingsKeysEnum.TenantEnableSprints]);
            if (isSprintEnabled) {
                if (selectedSprint != null) refreshData();
            } else {
                refreshData();
            }
        },
        [selectedSprint, rowsPerPage, page, search],
        500,
    );

    // const parsedStatuses = useMemo<SelectOptionsType[]>(() => {
    //     if (!itemStatuses) return [];
    //     return itemStatuses.map(u => ({
    //         label: u.title,
    //         value: u.id,
    //     }));
    // }, [itemStatuses]);

    // Helper to get filter label/value for chips

    const selectedField = useMemo(() => {
        return selectedDefaultForm?.formFieldsData?.find(x => x.shouldUseAsTheFieldToCreateItem);
    }, [selectedDefaultForm]);

    const columns = useMemo(() => {
        return tableBoardColumns(selectedDefaultForm?.formFieldsData ?? [], itemStatuses ?? [], handleRowClick);
    }, [selectedDefaultForm, itemStatuses]);

    return (
        <Box flex={1} minHeight={0} mr={1}>
            <AppTable<ItemDataResponse>
                columns={columns}
                data={items ?? []}
                tableHeadProps={{
                    sx: {
                        position: 'sticky',
                        top: 0,
                        zIndex: 2,
                    },
                    tableCellProps: {
                        sx: {bgcolor: 'white'},
                    },
                }}
                tableProps={{
                    stickyHeader: true,
                    sx: {
                        minWidth: '100%',
                        minHeight: 'calc(100vh - 320px)',
                        width: 'max-content',
                    },
                }}
                tableBodyProps={{
                    tableRowProps: {
                        sx: {
                            cursor: 'pointer',
                        },
                    },
                }}
                tableContainerProps={{
                    sx: {
                        flex: 1,
                        minHeight: 0,
                        display: 'block',
                        overflow: 'auto',
                        maxHeight: `calc(100vh - 300px)`,
                        width: '100%',
                    },
                }}
                onMultiRowSelectedChange={value => setRowSelection(value)}
                renderHeaderCell={header => {
                    const fieldType = header.column.columnDef.meta?.fieldType;
                    const defaultOptions = header.column.columnDef.meta?.options ?? [];
                    const colId = header.column.id;
                    const canFilter = header.column.getCanFilter();
                    return <>{canFilter && <Box display={'flex'} alignItems="center" gap={1}></Box>}</>;
                }}
                renderLeftHeader={
                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} width="100%">
                        <Box display={'flex'} alignItems={'center'}>
                            <TableViewMultiRowSelectedActions
                                selectedRows={selectedRow}
                                refreshTableData={refreshTableData}
                            />
                            {selectedField && (
                                <TableBoardViewAddNewItem
                                    selectedFeild={selectedField}
                                    refreshTableData={refreshTableData}
                                />
                            )}
                        </Box>
                        {/* <Box display={'flex'} alignItems={'center'}>
                            <AppTooltip title="Export Data">
                                <AppIconButton>
                                    <GetAppIcon />
                                </AppIconButton>
                            </AppTooltip>
                            <TableViewSortDrawer />
                            <TableViewFIlterDrawer />
                        </Box> */}
                    </Box>
                }
                showPagination
                pageCount={totalCount}
                pageIndex={page}
                pageSize={rowsPerPage}
                onPageChange={setPage}
                onPageSizeChange={setRowsPerPage}
                loading={getAllitemDataLoading}
                enableColumnResizing
                showColumnVisibilityToggle
            />
        </Box>
    );
};

export default TableBoardView;
